import { render, staticRenderFns } from "./PatientCard.vue?vue&type=template&id=4d73158d"
import script from "./PatientCard.vue?vue&type=script&lang=js"
export * from "./PatientCard.vue?vue&type=script&lang=js"
import style0 from "./PatientCard.vue?vue&type=style&index=0&id=4d73158d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports